import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useEffect, useCallback } from 'react';
import { usePopper } from 'react-popper';
import { Portal } from '../../Portal/Portal.js';
import { useBKJTimeInputContext } from './BKJTimeInput.context.js';
import { BKJTimeInputOptionsMapper } from './BKJTimeInputOptionsMapper.js';
import { StyledDropdown } from '../../BKJTimeInput/BKJTimeInput.styled.js';
const variantMap = {
    ComboBoxSeamlessRounded: 'SeamlessRounded',
};
const defaultPopperOptions = {
    placement: 'bottom-start',
    modifiers: [
        {
            name: 'flip',
            options: {
                allowedAutoPlacements: ['bottom', 'top'],
            },
        },
        {
            name: 'offset',
            options: {
                offset: [0, 8],
            },
        },
    ],
};
export const BKJTimeInputOptions = ({ $dropdownHeight, allowedAutoPlacements = ['bottom', 'top'] }) => {
    const { error, isOpen, parentRef, getMenuProps, anchorElement, dropdownElement, setDropdownElement, portalTargetElement, isDropdownReverse, setIsDropdownReverse, } = useBKJTimeInputContext();
    const popperOptions = useMemo(() => ({
        ...defaultPopperOptions,
        modifiers: (defaultPopperOptions.modifiers || []).map((modifier) => ({
            ...modifier,
            ...(modifier.name === 'flip' && {
                options: {
                    ...modifier.options,
                    allowedAutoPlacements,
                },
            }),
        })),
    }), [allowedAutoPlacements]);
    const { styles, state } = usePopper(anchorElement, dropdownElement, popperOptions);
    useEffect(() => {
        if (state?.placement) {
            const isReverse = state.placement.startsWith('top');
            if (isReverse !== isDropdownReverse) {
                setIsDropdownReverse(isReverse);
            }
        }
    }, [state?.placement, isDropdownReverse, setIsDropdownReverse]);
    const menuRef = useCallback((node) => {
        setDropdownElement((prev) => (prev !== node ? node : prev));
        parentRef.current = node;
    }, [setDropdownElement, parentRef]);
    if (!isOpen || !portalTargetElement)
        return null;
    const { 'aria-labelledby': _menuLabelledBy, ...menuProps } = getMenuProps({
        ref: menuRef,
        style: {
            ...styles['popper'],
            minWidth: anchorElement?.offsetWidth,
        },
    });
    return (_jsx(Portal, { targetElement: portalTargetElement, children: _jsx(StyledDropdown, { "$isOpen": isOpen, "$dropdownVariant": variantMap['ComboBoxSeamlessRounded'], "$dropdownHeight": $dropdownHeight, error: error, "aria-label": "Time options", onMouseDown: (e) => {
                // Prevent blur on input when clicking dropdown items
                e.preventDefault();
            }, ...menuProps, openBorderLocation: undefined, children: _jsx(BKJTimeInputOptionsMapper, {}) }) }));
};
//# sourceMappingURL=BKJTimeInputOptions.js.map